import { render, staticRenderFns } from "./ActionsCliente.vue?vue&type=template&id=7b9f4f4c"
import script from "./ActionsCliente.vue?vue&type=script&lang=js"
export * from "./ActionsCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports